import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

const normalizeInvoice = (inv) => ({
    ...inv,
    serviceName: inv.service_name,
    serviceType: inv.service_type,
    supplierName: inv.supplier_name,
    fileUid: inv.file?.uid ?? null,
    paymentProofFileUid: inv.payment_proof_file?.uid ?? null,
});

export const useDashboardSummary = () => {
    return useQuery({
        queryKey: ['dashboard-summary'],
        queryFn: () => api.getDashboardSummary(),
        staleTime: 10 * 60 * 1000,
    });
};

export const useDashboardInvoices = (params = {}) => {
    return useQuery({
        queryKey: ['dashboard-invoices', params],
        queryFn: async () => {
            const data = await api.getDashboardInvoices(params);
            return {
                ...data,
                invoices: (data.invoices ?? []).map(normalizeInvoice),
            };
        },
        staleTime: 2 * 60 * 1000,
    });
};
